import React from 'react';

import EditPencil from './EditPencil';

// Deal-credentials card.  Distinctive 3px gold top accent + large serif
// currency value.  Used in the v3 Tombstones list (cards mode).

interface Props {
  year: string | number;
  type: string; // e.g. "M&A", "Listing", "Capital Raise"
  value: string; // pre-formatted via formatZar
  client: string;
  project?: string; // optional project codename
  role?: string; // BSM role, e.g. "Sell-side advisor"; omitted when unrecorded
  sector?: string;
  when: string; // human-readable date e.g. "Nov 2025"
  onClick?: () => void;
  onEdit?: () => void;
}

const TombstoneCard = ({
  year,
  type,
  value,
  client,
  project,
  role,
  sector,
  when,
  onClick,
  onEdit
}: Props) => (
  <article
    className="tomb-card"
    onClick={onClick}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={
      onClick
        ? (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onClick();
            }
          }
        : undefined
    }
  >
    {onEdit && <EditPencil onClick={onEdit} ariaLabel="Edit tombstone" />}
    <div className="y">
      {year} · {type}
    </div>
    <div className="v">{value}</div>
    <div className="name">{client}</div>
    <div className="role">{[project, role].filter(Boolean).join(' — ')}</div>
    <div className="foot">
      {sector ? <span className="chip muted">{sector}</span> : <span />}
      <span className="when">{when}</span>
    </div>
  </article>
);

export default TombstoneCard;
